<template>
  <div class="page_declare">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="topForm">
          <el-form :inline="true" :model="listQuery2" class="re_down_form" label-width="80px" v-if="activeName > 1 && (activeName != '8'&&activeName != '9'&&activeName != '12')">
            <el-form-item label="项目" size="small">
              <el-select v-model="listQuery2.Projectid" placeholder="" value-key="Projectid" size="small" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="供应商" size="small">
              <el-select v-model="listQuery.name" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item,index) in serviceList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="隶属公司" size="small">
              <el-input v-model="listQuery2.ContractParty" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="实名是否通过" size="small" v-if="activeName == '2' && type=='add'" label-width="100px">
              <el-select v-model="listQuery2.isPassCheck" placeholder="" size="small" filterable clearable>
                <el-option label="所有" value=""></el-option>
                <el-option label="不通过" value="不通过"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :inline="true" :model="underQuery" class="re_down_form" label-width="94px" v-if="activeName == '8'||activeName == '9' ||activeName == '12'">
            <el-form-item label="项目" size="small" v-if="activeName != '8'">
              <el-select v-model="underQuery.objname" placeholder="" value-key="Projectid" size="small" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" size="small" v-if="activeName != '8'">
              <el-input v-model="underQuery.strEmpName" size="small" clearable></el-input>
            </el-form-item>

            <el-form-item label="项目" size="small" v-if="activeName == '8'">
              <el-select v-model="underQuery.strProjectName" placeholder="" value-key="Projectid" size="small" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" size="small" v-if="activeName == '8'">
              <el-input v-model="underQuery.strUserName" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1 && activeName>1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>申报端</el-breadcrumb-item>
          <el-breadcrumb-item>{{type=='add' ? '报增' : '报减'}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="tips">员工更改合同签约主体，请及时进行减员再增员（更换保险参保主体）。</div>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name" @changeType="changeType"></tabs>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="showTabs">
          <el-tab-pane :label="type=='add' ? '待入职商保' : ''" name="8"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? '在职未商保' : ''" name="9"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? '无需商保' : ''" name="12"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? '报增' : '报减'" name="1"></el-tab-pane>
          <el-tab-pane :label="type=='add' ?  '报增待确认' :  '报减待确认' " name="11"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? ( '报增待核（' + approveNum + '）' ) : ( '报减待核（' + approveNum + '）' ) " name="2"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? ( '报增被退回（' + returnNum + '）' ) : ( '报减被退回（' + returnNum + '）' )" name="3"></el-tab-pane>
          <el-tab-pane :label="'审批通过（' + passNum + '）'" name="4"></el-tab-pane>
          <el-tab-pane :label="'保司成功（' + successNum + '）'" name="6"></el-tab-pane>
          <el-tab-pane :label="'保司失败（' + failNum + '）'" name="7"></el-tab-pane>
          <el-tab-pane :label="type=='add' ? ( '报增历史数据（' + histotyNum + '）' ) : ( '报减历史数据（' + histotyNum + '）' )" name="5"></el-tab-pane>
          <el-tab-pane label="不联网" name="10"></el-tab-pane>
        </el-tabs>
        <!-- <el-tabs v-model="verifiedType" type="card" v-if="activeName == '2' || activeName == '4' || activeName == '5'">
          <el-tab-pane label="汇总" name="sum"></el-tab-pane>
          <el-tab-pane label="明细" name="detail"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="verifiedType" type="card" v-if="activeName == '3'">
          <el-tab-pane label="整批退回" name="sum"></el-tab-pane>
          <el-tab-pane label="单人次退回" name="detail"></el-tab-pane>
        </el-tabs> -->


        <!-- <el-popconfirm title="请确认是否提交本月初保审核？" @confirm="firstInsure" v-if="activeName==1">
          <el-button slot="reference" type="success" size="small" style="margin-right: 15px;margin-bottom: 10px;">提交初保审批</el-button>
        </el-popconfirm> -->
        <el-button v-if="activeName == '8'||activeName == '9'" size="small" type="success" style="margin-bottom: 10px;" @click="insDialogHandle('报增')">商保</el-button>
        <el-button v-if="activeName == '9'" size="small" type="warning" style="margin-bottom: 10px;" @click="noNeedIns" :loading="isBtnLoading">无需商保</el-button>
        <!-- <el-popconfirm :title="'请确认是否办理商保报减？'" @confirm="reduction()" style="margin:0 10px" v-if="activeName == '9'">
          <el-button type="info" slot="reference" size="small" v-preventReClick>商保报减</el-button>
        </el-popconfirm> -->
        <el-button type="primary" size="small" @click="expList2" :loading="isExping" v-if="activeName == '9' || activeName == '12'" v-preventReClick>导出</el-button>
        <el-button slot="reference" type="primary" size="small" style="margin-left: 15px;margin-bottom: 10px;" v-if="activeName>1 && activeName != '8' && activeName != '9' && activeName != '12' && totalCount>0" v-preventReClick @click="expList()">导出列表</el-button>

        <el-button type="warning" size="small" v-if="activeName==11" @click="batchConfirm()" style="margin-left: 15px;margin-bottom: 10px;">批量确认</el-button>

        <el-button slot="reference" type="primary" size="small" style="margin-left: 15px;margin-bottom: 10px;" v-if="activeName>1 && activeName != '8' && activeName != '9' && activeName != '12' && totalCount>0" v-preventReClick @click="expBatchDtlList()">导出明细列表</el-button>

        <!-- 报增列表 -->
        <el-table :data="tableData" v-if="activeName == '1' && type=='add'" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="InsuranceCode" label="险种代码" width="80" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Bntype" label="险种名称" width="310" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="年龄范围" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.AgelimitStart && row.AgelimitEnd ? row.AgelimitStart + '~' + row.AgelimitEnd : ''}}</template>
          </el-table-column>
          <el-table-column prop="MedicalinsuranceType" label="医保类型" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Price" label="保费" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IsCanDeduction" label="允许报减" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SafeguardStatement" label="保障说明" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="已生成保单" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column label="操作" align="center" fixed="right" min-width="120px" v-if="activeName == '1'">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-if="type=='add'" v-preventReClick @click="handelDeclare(row)">报增</el-button>
                <el-button type="text" v-if="type=='add'" v-preventReClick @click="BatchDeclare(row)">批量报增</el-button>
                <el-button type="text" v-if="type!='add'" v-preventReClick @click="handelDeclare(row)">报减</el-button>
                <el-button type="text" v-if="type!='add'" v-preventReClick @click="BatchDeclare(row)">批量报减</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0 && activeName == '1' && type=='add'" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>

        <!-- 报减界面 -->
        <div v-if="activeName=='1' && type=='reduction'">

          <el-button type="primary" size="small" v-preventReClick @click="BatchDeclare('')">批量报减</el-button>

          <span class="infoTips">
            <i class="el-icon-info"></i>
            单个减员,请前往“在保人员”操作
          </span>

          <!-- <el-form :model="declareForm" :rules="declareRules" :inline="true" ref="declareForm" label-width="130px">

            <el-form-item label="项目名称" prop="Insurance.Projectid">
              <el-select v-model="proName" placeholder="" value-key="Projectid" size="small" clearable filterable style="width:300px" @change="proChange">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="被保险人姓名" prop="userList[0].MainlinsuredName">
              <el-input v-model="declareForm.userList[0].MainlinsuredName" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="userList[0].Idtype">
              <el-select v-model="declareForm.userList[0].Idtype" placeholder="" size="small" clearable filterable style="width:300px">
                <el-option value="身份证"></el-option>
                <el-option value="护照"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="userList[0].MainlinsuredCardId">
              <el-input v-model="declareForm.userList[0].MainlinsuredCardId" style="width:300px" size="small"></el-input>
            </el-form-item>
            <el-form-item label="被保险人手机">
              <el-input v-model="declareForm.userList[0].MainlinsuredPhone" style="width:300px" size="small"></el-input>
            </el-form-item>

            <div class="btnBox">
              <el-button type="success" style="width: 180px;" v-preventReClick @click="confirmSubmitDeclare">提交</el-button>
            </div>
          </el-form> -->
        </div>

        <!-- 汇总 -->
        <el-table :data="tableData2" key="table2" v-if="Number(activeName) >1 && activeName != '8' && activeName != '9' && activeName != '12' && verifiedType =='sum'" @selection-change="handleSelectionChange" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column type="selection" width="40">
          </el-table-column>
          <el-table-column prop="CheckMsg" label="实名认证" align="center" width="90" v-if="activeName == '2' && type=='add'">
            <template slot-scope={row}>
              <span v-if="!row.CheckMsg" class="status-tag success">已通过</span>
              <el-tooltip class="item" effect="dark" :content="'未通过原因：' + row.CheckMsg" placement="top-start" v-else>
                <span class="status-tag danger">未通过</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="BatchNum" label="投保批次号" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="Projectid" label="项目ID" align="center" width="65">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="DepartmentName" label="部门" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <el-table-column prop="Service" label="客服" :show-overflow-tooltip="true" align="center" width="110">
          </el-table-column>
          <!-- <el-table-column prop="Name" label="项目批次号" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center" width="160">
          </el-table-column>
          <el-table-column prop="ContractParty" label="隶属公司" :show-overflow-tooltip="true" align="center" width="160">
          </el-table-column>
          <el-table-column prop="CreateTime" label="提交时间" align="center" width="110px">
            <template slot-scope={row}>{{ row.CreateTime ? row.CreateTime.split('T')[0] : ''}}</template>
          </el-table-column>
          <el-table-column prop="PendingAudit" label="待审核数" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ApproverState" label="状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Operator" label="操作人" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OperationalSource" label="来源" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ReturnReasons" label="退回原因" :show-overflow-tooltip="true" align="center" width="120px" v-if="activeName==3" fixed="right">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" :width="activeName == 3 || activeName == 2 ? '240px' : '150px'">
            <template slot-scope={row,$index}>
              <div class="eleTabBtn">
                <el-popover placement="right" :ref="'pop' + $index " width="1051" trigger="manual" style="margin-right: 10px;">
                  <div style="margin-bottom: 10px;">
                    <i class="el-icon-close cp" style="float: right;font-size: 20px;" @click="closePopover($index)"></i>
                  </div>
                  <div class="flex">
                    <el-form>
                      <el-form-item label="身份证号码" label-width="90px">
                        <el-input v-model="detailQuery.MainlinsuredCardId" style="width:200px" size="small" clearable></el-input>

                        <el-button type="success" size="small" v-preventReClick @click="getApprovalDetails()" style="margin-left: 15px;">搜索</el-button>

                        <el-button type="primary" size="small" v-preventReClick @click="expDtlList()" style="margin-left: 15px;">导出明细列表</el-button>
                      </el-form-item>

                    </el-form>
                  </div>

                  <el-table :data="detailTable" border v-loading="detLoading" class="doc_table">
                    <el-table-column width="110" property="BatchNum" label="批次号" align="center"></el-table-column>
                    <el-table-column width="80" property="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="156" property="MainlinsuredCardId" label="证件号码" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="80" property="MainlinsuredName" label="姓名" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="160" property="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="100" property="JobName" label="岗位" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="80" property="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="115" property="MainlinsuredPhone" label="手机号码" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="160" property="LaborContractUnit" label="劳动合同公司" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="120" property="ActualWorkUnit" label="工作单位" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <el-table-column width="150" property="InsuranceName" label="险种名称" :show-overflow-tooltip="true" align="center"></el-table-column>
                    <!-- <el-table-column width="100" property="OrderNum" label="订单号" :show-overflow-tooltip="true" align="center"></el-table-column> -->
                    <el-table-column width="100" property="CreateTime" label="申请时间" align="center">
                      <template slot-scope={row}>
                        {{ row.CreateTime ? row.CreateTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" property="InsuranceStartTime" label="保障开始" align="center">
                      <template slot-scope={row}>
                        {{ row.InsuranceStartTime ? row.InsuranceStartTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" property="InsuranceEndTime" label="保障结束" align="center">
                      <template slot-scope={row}>
                        {{ row.InsuranceEndTime ? row.InsuranceEndTime.split('T')[0] : '' }}
                      </template>
                    </el-table-column>
                    <el-table-column width="100" v-if="activeName == 7" property="InsuredErrMsg" label="失败原因" align="center" fixed="right">
                    </el-table-column>
                    <el-table-column width="90" label="操作" align="center" fixed="right" v-if="activeName==3 || activeName==2">
                      <template slot-scope={row}>
                        <div class="eleTabBtn">
                          <el-button type="text" v-preventReClick @click="editDtl(row)" v-if="activeName==2 && row.CheckState==1 && type=='add'">编辑</el-button>
                          <el-button type="text" @click="editBackDtl(row)" v-if="activeName==3">编辑</el-button>
                          <el-button type="text" @click="delBackDtl(row)" v-if="activeName==3">删除</el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination v-if="detTotal>0" @current-change="detCurrentChange" :current-page.sync="detailQuery.pageNum" :page-size="Number(detailQuery.pageSize)" @size-change="detHandleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="detTotal"></el-pagination>
                  </div>
                  <el-button type="text" slot="reference" v-preventReClick @click="getDetail(row,$index)">查看明细</el-button>
                </el-popover>
                <!-- <el-button type="text" style="margin-left: 10px;" v-if="activeName==2">撤销</el-button> -->
                <!-- <el-button type="text" v-if="activeName==2" @click="approve(row)">审批</el-button> -->
                <el-button type="text" v-if="activeName==11" @click="confirmc(row.Id)">确认</el-button>
                <el-button type="text" v-if="activeName==2" @click="goBack(row)">退回</el-button>
                <el-button type="text" v-preventReClick @click="reimport(row)" v-if="activeName==3">重新导入</el-button>
                <el-button type="text" v-preventReClick @click="resubmit(row)" v-if="activeName==3">重新提交</el-button>
                <el-popconfirm v-if="activeName==3" :title="'请确定批次号为' + row.BatchNum + ' 的是否作废？'" @confirm="approverCancel(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
                <el-button type="text" v-if="activeName==2 && row.CheckMsg" @click="passAuth(row)">通过认证</el-button>
                <el-popconfirm v-if="activeName==11" title="请确定是否作废？" @confirm="conrirmDel(row.Id)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0 && Number(activeName) >1 && activeName != '8' && activeName != '9' && activeName != '12' && verifiedType=='sum'" @current-change="currentChange2" :current-page.sync="listQuery2.pageNum" :page-size="Number(listQuery2.pageSize)" @size-change="handleSizeChange2" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>

        <!-- 未在保、待入职模块 -->
        <div v-if="activeName == '8'||activeName == '9' || activeName=='12'" class="ins_dialog_box">
          <el-table ref="multipleTable" class="re_table" border v-loading="tableLoading" :highlight-current-row="true" @selection-change="underSelChange" :data="notUnderData" style="width:100%">
            <el-table-column type="selection" align="center" width="55" label-class-name="com_Selection"></el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" v-if="item.StrColumName != '序号'" :key="index+'A'" :min-width="item.StrColumName.indexOf('序号')>-1||item.StrColumName.indexOf('性别')>-1||item.StrColumName.indexOf('年龄')>-1||item.StrColumName.indexOf('籍贯')>-1 ? '50px' : item.StrColumName.indexOf('项目名称')>-1||item.StrColumName.indexOf('客户名称')>-1||item.StrColumName.indexOf('原因')>-1||item.StrColumName.indexOf('地')>-1||item.StrColumName.indexOf('时间')>-1 ||item.StrColumName.indexOf('日期')>-1 ||item.StrColumName.indexOf('渠道推荐人')>-1 || item.StrColumName == '合同（协议）类型'?'170px':'110px'" align="center" :fixed="item.StrColumName=='序号'||item.StrColumName=='姓名'||item.StrColumName=='联系方式'">
                <template slot-scope="{row}">
                  <span v-if="item.StrColumId == 'StrUserName'&&row.sendtype == '1'" class="send_icon">
                    {{isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}
                  </span>
                  <i v-if="item.StrColumId == 'StrUserName'&&row.sendtype == '1'" class="el-icon-s-comment"></i>
                  <span v-else-if="item.StrColumName == '入职时间'">{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId].replace('T',' ')}}</span>
                  <!-- <span v-else-if="(item.StrColumName == '面试时间')" style="cursor: pointer;color:#333;font-weight: bold;text-decoration: underline;" title="点击可修改面试时间">{{ row[item.StrColumId]}}<i class="el-icon-edit" style="font-size: 14px;color: #333;"></i></span> -->
                  <span v-else-if="item.StrColumName.indexOf('在职天数')>-1">{{ isMinus(row[item.StrColumId]) ? '0' : row[item.StrColumId]}}</span>
                  <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId]}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <div class="block">
            <el-pagination @current-change="underCurrentChange" :current-page.sync="underQuery.currpage" :page-size="underQuery.pagecount" @size-change="underSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="underTotal"></el-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- 报增弹窗 -->
    <el-dialog :title="type == 'add' ? '报增' : '报减'" :visible.sync="showDeclare" width="980px">
      <div class="declareForm">
        <el-form :model="declareForm" :rules="declareRules" :inline="true" ref="declareForm" label-width="130px">
          <el-form-item label="险种名称">
            <!-- <el-select v-model="declareForm.Insurance.InsuranceId" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option v-for="(item,index) in planList" :key="index" :label="item.InsuranceName" :value="item.Id"></el-option>
            </el-select> -->
            <el-input v-model="insuranceName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="可参保保单" prop="policy">
            <el-select v-model="policy" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange">
              <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保障期限">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="项目名称" prop="Insurance.Projectid">
            <el-select v-model="proName" placeholder="" value-key="Projectid" size="small" clearable filterable style="width:300px" @change="proChange">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="被保险人姓名" prop="userList[0].MainlinsuredName">
            <el-input v-model="declareForm.userList[0].MainlinsuredName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="userList[0].Idtype">
            <el-select v-model="declareForm.userList[0].Idtype" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="身份证"></el-option>
              <el-option value="护照"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="userList[0].MainlinsuredCardId">
            <el-input v-model="declareForm.userList[0].MainlinsuredCardId" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="被保险人手机" prop="userList[0].MainlinsuredPhone">
            <el-input v-model="declareForm.userList[0].MainlinsuredPhone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="岗位" prop="userList[0].JobName">
            <template #label>
              <span>岗位
                <el-tooltip placement="top" effect="light" v-if="JobNameTip">
                  <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                    <div v-for="(item,index) in JobNameTip" :key="index">{{ item }}</div>
                    <!-- {{ JobNameTip }} -->
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="declareForm.userList[0].JobName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="职业类别" prop="userList[0].JobClasss">
            <template #label>
              <span>职业类别
                <el-tooltip :content="JobClasssTip" placement="top" effect="light" v-if="JobClasssTip">
                  <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                    {{ JobClasssTip }}
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="declareForm.userList[0].JobClasss" placeholder="" clearable size="small" style="width:300px">
              <el-option v-for="(item,index) in JobClasssList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工属性" prop="userList[0].EmployeeAttribute">
            <el-select v-model="declareForm.userList[0].EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="劳动合同公司" prop="userList[0].LaborContractUnit">
            <el-select v-model="declareForm.userList[0].LaborContractUnit" placeholder="" clearable size="small" style="width:300px" filterable>
              <el-option v-for="(item,index) in legList" :key="index" :value="item.companyName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeclare = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmitDeclare" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 批量报增弹窗 -->
    <el-dialog :title="type == 'add' ? '批量报增' : '批量报减'" :visible.sync="showBatchDeclare" :show-close="failBase64 && !hasDownload ? false : true" width="1060px">
      <div class="declareForm">
        <el-form :model="declareForm" :rules="batchRules" :inline="true" ref="declareForm" label-width="130px">
          <el-form-item label="项目名称" prop="Insurance.ProjectName">
            <el-select v-model="proName" placeholder="" value-key="Projectid" size="small" clearable filterable style="width:300px" @change="proChange2">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="险种名称" v-if="type == 'add'">
            <el-input v-model="insuranceName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>

          <el-form-item label="险种类型" v-if="type == 'add'">
            <el-input v-model="insuranceName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>

          <el-form-item label="可参保保单" prop="policy2" v-if="type == 'add'">
            <el-select v-model="policy2" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange2">
              <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="保障期限" v-if="type == 'add'">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="batchForm.Insurance.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="batchForm.Insurance.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
            </div>
          </el-form-item>

          <!-- <el-form-item label="保单号" prop="name">
            <el-input v-model="declareForm.name" style="width:200px" size="small"></el-input>
          </el-form-item> -->

          <el-form-item label="导入Excel" prop="url">
            <div class="file-box">
              <input readonly style="width: 300px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn cp">上传</label>
            </div>
          </el-form-item>

          <el-form-item label="注意事项" v-if="note">
            <div class="insureNote">{{note}}</div>
          </el-form-item>

          <div>
            <el-form-item label="导入模板">
              <el-button type="text" class="blueName cp" @click="downImportTemp">下载模板</el-button>
            </el-form-item>
          </div>
          <el-form-item label="导入失败原因" v-if="failReason">
            <div class="insureNote overSet">{{failReason}}</div>
            <el-button type="text" v-if="failBase64" class="blueName cp" @click="downFailTemp">下载失败名单</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBatch" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick :disabled="!isUploadSuccess || !batchForm.userListFile || (failBase64 ? true : false)" style="margin-left:10px;" @click="confirmSubmitBatch" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="showEditBackDtl" width="990px">
      <div class="backDtlInfo">
        <el-form :model="backDtlInfo" :inline="true" ref="backDtlInfo" label-width="130px" :rules="backRules">

          <el-form-item label="员工属性" prop="EmployeeAttribute">
            <el-select v-model="backDtlInfo.EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件类型" prop="Idtype">
            <el-select v-model="backDtlInfo.Idtype" placeholder="" clearable size="small" style="width:300px">
              <el-option value="身份证"></el-option>
              <el-option value="护照"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件号码" prop="MainlinsuredCardId">
            <el-input v-model="backDtlInfo.MainlinsuredCardId" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="姓名" prop="MainlinsuredName">
            <el-input v-model="backDtlInfo.MainlinsuredName" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="岗位" prop="JobName">
            <el-input v-model="backDtlInfo.JobName" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="职业类别" prop="JobClasss">
            <el-select v-model="backDtlInfo.JobClasss" placeholder="" clearable size="small" style="width:300px">
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="手机号码" prop="MainlinsuredPhone">
            <el-input v-model="backDtlInfo.MainlinsuredPhone" style="width:300px" size="small"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditBackDtl = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditBackDtl" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <div class="insureApprove">

      <el-dialog title="失败原因" :visible.sync="showConfirmFail" width="500px">
        <div class="declareForm">
          <el-form label-width="100px">
            <el-form-item label="失败原因" v-if="failReason">
              <div class="insureNote overSet">{{failReason}}</div>
              <el-button type="text" v-if="failBase64" class="blueName cp" @click="downFailTemp">下载失败原因</el-button>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showConfirmFail = false" size="small">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 审批 -->
      <el-dialog title="审批确认" :visible.sync="showApprove" width="500px">
        <span>请确认批次为 {{approveBatch}} 是否通过审批？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showApprove = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmPass" size="small">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 退回 -->
      <el-dialog title="退回确认" :visible.sync="showBack" width="500px">
        <div style="margin-bottom: 15px;">请确认批次为 {{approveBatch}} 是否退回？</div>
        <el-form label-width="68px">
          <el-form-item label="退回原因">
            <el-input v-model="ReturnReasons" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBack = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmBack" size="small">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 删除 -->
      <el-dialog title="删除确认" :visible.sync="showDel" width="500px">
        <div style="margin-bottom: 15px;">请确认是否删除 {{ delName }} ？ </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBack = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmDel" size="small">确认</el-button>
        </span>
      </el-dialog>

      <!-- 重新提交审批 -->
      <el-dialog title="重新提交审批" :visible.sync="showResubmit" width="500px">
        <span>请确认批次为 {{approveBatch}} 是否重新提交审批？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showResubmit = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmResubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 重新导入 -->
      <el-dialog title="重新导入" :visible.sync="showReimport" width="500px">
        <el-form label-width="80px">
          <el-form-item label="导入Excel">
            <div class="file-box">
              <input readonly style="width: 300px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf2(this)" ref="upload">
              <label for="fileInput" class="file-btn cp">上传</label>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showReimport = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick :disabled="!reimportForm.userListFile" style="margin-left:10px;" @click="confirmReimport" size="small">确 认</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="reading">
      <el-dialog :visible.sync="visibleReading" width="500px" :show-close="false" :close-on-click-modal="false">
        <div class="readDialog">
          <div class="diaTitle">名单确认</div>
          <div style="margin-top:20px;font-size: 15px;">
            <div class="note_txt">请确认名单是否无误，如有变动请及时增减员</div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="viewList" size="small">查看在保名单</el-button>
          <!-- <el-button type="primary" size="small" style="margin-right: 10px;" @click="closeRead">确 认</el-button> -->
        </span>
      </el-dialog>
    </div>

    <el-dialog title="批量商保" :visible.sync="insuranceVisible" width="1150px" class="ins_dialog_box">
      <el-form :model="insQuery" :inline="true" :rules="insRules" ref="insForm" label-width="100px">
        <el-form-item label="险种名称" prop="InsuranceId">
          <el-select v-model="insQuery.InsuranceId" placeholder="" size="small" clearable filterable style="width:300px" @change="insChange">
            <el-option v-for="(item,index) in tableData" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职业类别" prop="JobClasss">
          <template #label>
            <span>职业类别
              <el-tooltip :content="JobClasssTip" placement="top" effect="light">
                <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                  参考《职业分类表》
                </div>
                <i class="el-icon-question cp"></i>
              </el-tooltip>
            </span>
          </template>
          <el-select v-model="insQuery.JobClasss" placeholder="" clearable size="small" style="width:300px">
            <el-option v-for="(item,index) in JobClasssList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工属性" prop="EmployeeAttribute">
          <el-select v-model="insQuery.EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
            <el-option value="长期工"></el-option>
            <el-option value="临时工"></el-option>
            <el-option value="日结工"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位名称" prop="JobName">
          <template #label>
            <span>岗位
              <el-tooltip placement="top" effect="light">
                <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                  <div>需要具体细化，参考《职业分类表》进行填写</div>
                </div>
                <i class="el-icon-question cp"></i>
              </el-tooltip>
            </span>
          </template>
          <el-input v-model="insQuery.JobName" @blur="changeJobName(insQuery.JobName)" style="width:300px" size="small" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="note_ins_txt">备注：只有姓名和身份证一致的数据才会申报商保。</div>
      <el-table :data="insuranceData" class="ele_table" border max-height="400px" style="width:100%;">
        <el-table-column label="*姓名" align="center" min-width="120px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrUserName" size="small" clearable style="width:100px;" v-if="activeName=='8'"></el-input>
            <el-input v-model="row.StrEmpName" size="small" clearable style="width:100px;" v-if="activeName!='8'"></el-input>
            <!-- <div v-if="row.errorTxt" class="err_txt">{{row.errorTxt}}</div> -->
          </template>
        </el-table-column>
        <el-table-column label="*身份证" align="center" width="220px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrIdCard" size="small" clearable style="width:190px;"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="LaborContractUnit" label="劳动合同公司" align="center" width="150px">
          <template slot-scope={row}>
            <el-select v-model="row.LaborContractUnit" placeholder="" clearable size="small" style="width:120px" filterable>
              <el-option v-for="(item,index) in legList" :key="index" :value="item.companyName"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="是否一致" :show-overflow-tooltip="true" align="center" min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.errorTxt}}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" :show-overflow-tooltip="true" align="center" min-width="100px">
          <template slot-scope="{row}">
            <span>{{row.StrMobile}}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" :show-overflow-tooltip="true" align="center" min-width="120px">
          <template slot-scope="{row}">
            <span>{{row.StrprojectName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="JobName" label="岗位名称" align="center" width="140px">
          <template slot-scope="{row}">
            <el-input v-model="row.CustomerJobName" size="small" clearable style="width:120px;"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="insuranceVisible = false" size="small">取消</el-button>
        <el-button type="primary" size="small" :loading="insLoading" @click="saveInsureHandle">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="showWarnMsg" width="700px">
      <div v-html="warnMsg">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWarnMsg = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="showEditDtl" width="500px">
      <div class="backDtlInfo">
        <el-form :model="DtlInfo" ref="DtlInfo" label-width="130px" :rules="backRules">

          <el-form-item label="证件号码" prop="MainlinsuredCardId">
            <el-input v-model="DtlInfo.MainlinsuredCardId" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="姓名" prop="MainlinsuredName">
            <el-input v-model="DtlInfo.MainlinsuredName" style="width:300px" size="small"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDtl = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEditDtl" size="small">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  import {
    forEach
  } from 'jszip';
  import {
    row
  } from "mathjs";
  export default {
    components: {
      tabs
    },
    data() {
      var validatetInsuranceTime = (rule, value, callback) => {
        if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障开始时间"));
        } else if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障结束时间"));
        } else {
          callback();
        }
      };
      var validatetpro = (rule, value, callback) => {
        if (!this.batchForm.Insurance.ProjectName) {
          callback(new Error("请选择项目"));
        } else {
          callback();
        }
      };
      var validatetPolicy = (rule, value, callback) => {
        if (!this.policy) {
          callback(new Error("请选择可参保保单"));
        } else {
          callback();
        }
      };
      var validatetPolicy2 = (rule, value, callback) => {
        if (!this.policy2) {
          callback(new Error("请选择可参保保单"));
        } else {
          callback();
        }
      };
      return {
        name: '/reportIncrease',
        listQuery: {
          pageNum: 1,
          pageSize: 10
        },
        showDropScreen: -1,
        roletype: localStorage.loginRoletype,
        type: 'add', //报增or报减
        activeName: '1',
        verifiedType: 'sum', //汇总/明细
        loading: false,
        tableData: [],
        proName: '',
        insuranceName: '', //险种名称
        MedicalinsuranceType: '', //医保类型
        validityStartTime: '', //保障期限
        validityEndTime: '',
        declareForm: { //报增减表单
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userList: [{
            MainlinsuredName: '', //姓名
            MainlinsuredCardId: '', //证件号
            Idtype: '', //证件类型
            MainlinsuredPhone: '', //手机号码
            JobName: '', //岗位名称
            JobClasss: '', //职业类别
            EmployeeAttribute: '', //员工属性
            LaborContractUnit: '',
          }]
        },
        declareRules: {
          'Insurance.InsuranceStartTime': {
            required: true,
            validator: validatetInsuranceTime,
            trigger: "change",
          },
          'policy': {
            required: true,
            validator: validatetPolicy,
            trigger: "change",
          },
          'Insurance.Projectid': {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
          'userList[0].MainlinsuredName': {
            required: true,
            message: "请输入被保险人姓名",
            trigger: "blur",
          },
          'userList[0].Idtype': {
            required: true,
            message: "请选择被证件类型",
            trigger: "change",
          },
          'userList[0].MainlinsuredCardId': {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
          'userList[0].MainlinsuredPhone': {
            required: true,
            message: "请输入被保险人手机号码",
            trigger: "blur",
          },
          'userList[0].JobName': {
            required: true,
            message: "请输入岗位",
            trigger: "blur",
          },
          'userList[0].JobClasss': {
            required: true,
            message: "请选择职业类别",
            trigger: "change",
          },
          'userList[0].EmployeeAttribute': {
            required: true,
            message: "请选择员工属性",
            trigger: "change",
          },
          'userList[0].LaborContractUnit': {
            required: true,
            message: "请选择劳动合同公司",
            trigger: "change",
          },
        },
        batchRules: {
          'Insurance.ProjectName': {
            required: true,
            validator: validatetpro,
            trigger: "change",
          },
          'policy2': {
            required: true,
            validator: validatetPolicy2,
            trigger: "change",
          },
        },
        fileName: '', //文件名称
        serviceList: ['部门1', '部门2'],
        proNameList: [], //项目列表
        showDeclare: false, //增/减员弹窗
        showBatchDeclare: false, //批量增减员弹窗
        listQuery2: {
          Projectid: '', //项目
          ContractParty: '', //隶属公司
          BusinessType: 1, //报增/报减
          ApproverState: '', //审批状态
          pageNum: 1,
          pageSize: 10
        },
        tableData2: [],
        totalCount: 0,
        detailQuery: {
          Id: '',
          MainlinsuredCardId: '', //身份证号码
          ServiceProviderStatu: '', //保司失败参数
          pageNum: 1,
          pageSize: 10
        },
        detTotal: 0,
        approveIds: '', //审批ID
        approveBatch: '', //批次
        showApprove: false, //审批弹窗
        detailTable: [], //明细
        detTotal: 0, //明细总数
        isBtnLoading: false,
        detLoading: false,
        batchForm: {
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userListFile: '',
        },
        isUploadSuccess: false, //是否上传成功
        ispending: false,
        JobClasssList: ['1-4类', '5类'],
        JobNameTip: '',
        JobClasssTip: '',
        showBack: false, //退回弹窗
        ReturnReasons: '', //退回原因
        policy: '', //可参保时间段
        policyList: [], //可参保时间段列表
        policy2: '',
        approveNum: 0, //待审批数量
        returnNum: 0, //退回数量
        passNum: 0, //通过数量
        successNum: 0, //保司成功数量
        failNum: 0, //保司失败数量
        histotyNum: 0, //历史数据数量
        backDtlInfo: {
          Id: '',
          MainlinsuredName: '',
          Idtype: '',
          MainlinsuredCardId: '',
          MainlinsuredPhone: '',
          JobName: '',
          EmployeeAttribute: '',
          JobClasss: '',
        },
        showEditBackDtl: false, //退回明细个人编辑弹窗
        backRules: {
          'EmployeeAttribute': {
            required: true,
            message: "请选择员工属性",
            trigger: "change",
          },
          'Idtype': {
            required: true,
            message: "请选择证件类型",
            trigger: "change",
          },
          'MainlinsuredCardId': {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
          'MainlinsuredName': {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          'JobName': {
            required: true,
            message: "请输入岗位",
            trigger: "blur",
          },
          'JobClasss': {
            required: true,
            message: "请选择职业类别",
            trigger: "blur",
          },
          'MainlinsuredPhone': {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        },
        showDel: false,
        delId: '',
        delName: '',
        showResubmit: false,
        showReimport: false,
        showConfirmFail: false,
        reimportForm: {
          userListFile: '', //查询导入文件BASE64
          oldid: '', //重新导入ID
        },
        note: '', //注意事项
        multipleSelection: [],
        visibleReading: false,
        failReason: '', //失败原因
        failBase64: '', //失败名单文件
        hasDownload: false, //是否下载失败名单
        // 未在保
        notUnderData: [],
        tableLoading: false,
        // 未在保表头
        tableTitle: [],
        underMultipleList: [],
        underQuery: {
          StrnowState: '待入职', //状态
          objname: '', // 项目名称
          strEmpName: '', // 姓名
          strMobile: '', // 联系方式
          strJobInf: '', //岗位
          strSource: '', //来源
          strreuser: '', //招聘顾问
          strUserkf: '', //客服
          stroutid: '', //导出选中id
          currpage: 1, // 分页
          perpage: 10,
          strSourcejl: '', //简历来源
          roletype: localStorage.loginRoletype,
          SignatureStatus: '0', //签约状态
          insuranceStatus: ''
        },
        // 表头参数
        titleQuery: {
          ststus: '已约面'
        },
        underTotal: 0,
        isExping: false,
        insuranceVisible: false,
        insQuery: {
          BusinessType: 1, //1报增  报减
          InsuranceId: '', //险种id
          ProjectName: '', //项目名称
          OrderNum: '', //订单号可不传
          Projectid: '', //项目id
          JobName: '', //岗位名称
          // InsuranceStartTime:'',//保障期限
          // InsuranceEndTime:'',
          JobClasss: '', //职业类别
          EmployeeAttribute: '' //员工属性
        },
        insRules: {
          InsuranceId: {
            required: true,
            message: "请选择险种",
            trigger: "change"
          },
          JobClasss: {
            required: true,
            message: "请选择职业类别",
            trigger: "change"
          },
          EmployeeAttribute: {
            required: true,
            message: "请选择员工属性",
            trigger: "change"
          },
          JobName: {
            required: true,
            message: "请输入岗位名称",
            trigger: "blur"
          }
        },
        // 批量商保的人
        insuranceData: [],
        insLoading: false,
        warnMsg: '',
        showWarnMsg: false,
        // 更新人员信息
        updateOneList: [],
        showTabs: true,
        roleName: localStorage.roleName,
        showEditDtl: false,
        DtlInfo: {
          Id: '',
          ParentId: '',
          MainlinsuredName: '',
          MainlinsuredCardId: '',
        },
        dialogVisible4: false,
        isIndeterminate: true,
        checkAll: false,
        checkedFields: [],
        fixedfields: [],
        tableclumn: [],
        tableclumn1: [],
        tableclumn2: [],
        allFieldList: [],
        workState: '在职',
        legList: [],
      }
    },
    created() {
      if (this.roleName == '客户在线') {
        this.$router.push({
          path: '/underGuarantee'
        })
      }
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        localStorage.setItem("insureActive", this.$route.query.type)
        if (this.type == 'reduction') {
          this.declareForm.Insurance.BusinessType = 0;
          this.batchForm.Insurance.BusinessType = 0;
          this.listQuery2.BusinessType = 0;
        }
      } else {
        localStorage.setItem("insureActive", 'add')
      }
      if (this.$route.query.currAct != undefined && this.$route.query.currAct) {
        this.activeName = this.$route.query.currAct
        this.underQuery.SignatureStatus = '0';
        this.underQuery.insuranceStatus = '';
        this.underQuery.currpage = 1;
        this.getTableTitleLists()
      }
      this.getReminderTag();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      // 未在保多选
      underSelChange(val) {
        this.underMultipleList = val;
      },
      // 未在保分页
      underCurrentChange(val) {
        this.underQuery.currpage = Number(val)
        this.getList()
      },
      // 判断在职天数是否是负数
      isMinus(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || Number(o) < 0
      },
      underSizeChange(val) {
        this.underQuery.currpage = 1
        this.underQuery.pagecount = Number(val)
        this.getList()
      },
      // 商保
      insDialogHandle(type) {
        let that = this
        if (this.isNull(this.underMultipleList)) {
          that.$message({
            type: 'warning',
            message: '请选择商保的数据'
          })
          return false;
        } else {
          that.insuranceData = JSON.parse(JSON.stringify(that.underMultipleList));
          let id = that.underMultipleList[0].Projectid;
          // 判断选中的数据是否是同一个项目
          if ((that.underMultipleList.some(v => v.Projectid != id)) == true) {
            that.$message({
              type: 'warning',
              message: '存在不同项目的数据,不能操作,请选择同一个项目或选中项目筛选后搜索再批量选择数据操作'
            })
            return false;
          } else {
            let item = that.insuranceData[0]
            that.insQuery.ProjectName = this.activeName == '8' ? item.StrprojectName : item.StrObjName;
            that.insQuery.Projectid = this.activeName == '8' ? item.Projectid : '';
            if (type == '报增') {
              that.insQuery.BusinessType = 1
            }
            if (type == '报减') {
              that.insQuery.BusinessType = 0
            }
            for (let i = 0; i < that.insuranceData.length; i++) {
              let element = that.insuranceData[i];
              that.$set(element, "RealName", '');
              that.$set(element, "CardIDRet", '');
              that.$set(element, "errorTxt", '');
              that.$set(element, "LaborContractUnit", '');
              if (this.activeName != 8) {
                that.$set(element, "CustomerJobName", element.StrJobInf);
              }
            }
            // that.getInsurancManageByUserid()
            that.insuranceVisible = true
          }
        }
      },
      changeJobName(val) {
        if (val) {
          this.insuranceData.forEach(element => {
            element.CustomerJobName = val
          });
        }
      },
      // 选择险种
      insChange(val) {
        if (!this.isNull(val)) {
          this.getPolicyList(val)
          // this.getInsurancCategory(val)
        }
      },
      // 商保保存
      async saveInsureHandle() {
        let that = this;
        let Insurance = {
          BusinessType: that.insQuery.BusinessType,
          InsuranceId: that.insQuery.InsuranceId,
          ProjectName: that.insQuery.ProjectName,
          Projectid: that.insQuery.Projectid
        }
        if (that.insuranceData.some(val => that.isNull(val.StrUserName))) {
          that.$message({
            type: 'warning',
            message: '姓名不能为空，请输入姓名'
          })
          return
        }
        if (that.insuranceData.some(val => that.isNull(val.StrIdCard))) {
          that.$message({
            type: 'warning',
            message: '身份证不能为空，请输入身份证'
          })
          return
        }
        let userList = [];
        this.updateOneList = []
        for (let i = 0; i < that.insuranceData.length; i++) {
          let element = that.insuranceData[i];
          let query = {
            strIdCard: element.StrIdCard,
            username: this.activeName == '8' ? element.StrUserName : element.StrEmpName,
            banknum: '',
            ProjectId: this.activeName == '8' ? element.Projectid : '',
            ProjectName: this.activeName == '8' ? element.StrprojectName : element.StrObjName,
          }
          await xz.getcheckidcard(query).then(res => {
            // console.log('ee', res)
            if (res.status != 'ok') {
              that.$set(element, "RealName", res.RealName);
              that.$set(element, "CardIDRet", res.CardIDRet);
              that.$set(element, "errorTxt", '身份证与姓名不匹配' + (res.RealName ? ',真实姓名：' + res.RealName : '') + (res.CardIDRet ? ',身份证：' + res.CardIDRet : ''));
              if (res.CardIDRet) {
                that.$set(element, "StrIdCard", '');
              }
              if (res.RealName) {
                that.$set(element, "StrUserName", '');
              }
              if (that.isNull(res.CardIDRet) && that.isNull(res.RealName)) {
                that.$set(element, "StrUserName", '');
              }
              // that.$message.error('身份证与姓名不匹配');
            } else {
              that.$set(element, "errorTxt", '一致');
              userList.push({
                MainlinsuredName: this.activeName == '8' ? element.StrUserName : element.StrEmpName,
                MainlinsuredCardId: element.StrIdCard,
                Idtype: "身份证",
                MainlinsuredPhone: this.activeName == '8' ? element.StrMobile : element.StrPhoneNum,
                JobName: element.CustomerJobName,
                JobClasss: that.insQuery.JobClasss,
                EmployeeAttribute: that.insQuery.EmployeeAttribute,
                LaborContractUnit: element.LaborContractUnit
              })
              that.updateOneList.push({
                GdststusId: element.GdststusId,
                StrIdCard: element.StrIdCard,
                StrUserName: this.activeName == '8' ? element.StrUserName : element.StrEmpName,
              })
            }
          })
        }
        let query = {
          Insurance: Insurance,
          userList: userList
        }
        // console.log('query1',query)
        that.$refs["insForm"].validate((valid) => {
          if (valid) {
            if (that.isNull(query.userList)) {
              that.$message.error('身份证与姓名都不匹配');
              return
            } else {
              that.insLoading = true
              xz.reportAddApprov(query, this.roletype).then(res => {
                if (res.status == 'ok') {
                  that.getList();
                  that.updateStatusinfo(that.updateOneList);
                  that.insuranceVisible = false;
                  that.$message.success('操作成功！');
                } else {
                  that.$message.error(res.msg);
                }
                that.insLoading = false
              })
            }
          }
        })
      },
      // 保存更新入职/待入职人员信息
      updateStatusinfo(query) {
        xz.updateStatusinfo(query).then(res => {
          if (res.status == 'ok') {

          } else {
            this.$message.error('更新人员信息出错！');
          }
        })
      },
      // 获取表头
      getTableTitleLists() {
        if (this.activeName == '9' || this.activeName == '12') {
          xz.getJbbasePageColumnList('JB_emp_UserBase', '').then((res) => {
            if (res && res.msg.length > 0) {
              try {
                res.msg.forEach((element) => {
                  if (element.StrColumName == "身份证号码") {
                    let a1 = {
                      StrColumId: "idcardJudge",
                      StrColumName: "判定",
                    };
                    let a2 = {
                      StrColumId: "sex",
                      StrColumName: "性别",
                    };
                    let a3 = {
                      StrColumId: "birth",
                      StrColumName: "出生年月",
                    };
                    let a4 = {
                      StrColumId: "age",
                      StrColumName: "年龄",
                    };
                    res.msg.splice(element.IntOrderId + 1, 0, a1, a2, a3, a4);
                    this.tableTitle = res.msg;
                    this.getList();
                    throw new Error("ending");
                  }
                });
              } catch (e) {
                if (e.message != "ending") throw e;
              }
              this.tableTitle = res.msg;
            } else {
              this.tableTitle = [];
            }
          });
        } else {
          xz.getProcessColumnList(this.titleQuery.ststus).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            } else {
              this.tableTitle = []
            }
          })
        }
      },
      // 获取列表
      getList() {
        this.tableLoading = true
        if (this.activeName == '9' || this.activeName == '12') {
          xz.bgetempcustlist(this.underQuery, this.roletype, 'ByPerson').then((res) => {
            if (res.status == 'ok') {
              try {
                // res.data.forEach(e => {
                //   if (e.StrIdCard) {
                //     var arr = this.getBirth(e.StrIdCard)
                //     var age = arr[0];
                //     var birth = arr[1];
                //     var sex = arr[2];
                //     e['age'] = age;
                //     e['birth'] = birth;
                //     e['sex'] = sex
                //   }
                // });
              } catch (e) {
                console.log(e)
              }
              this.notUnderData = res.data;
              this.underTotal = res.count;
              this.tableLoading = false;
            } else {
              this.notUnderData = [];
              this.underTotal = 0;
              this.tableLoading = false;
            }
          })
        } else {
          let pagename = ''
          if (this.activeName == '8') {
            pagename = 'getsignResumeListsInsu'
          } else {
            pagename = 'GetsignResumeListsonworkInsu'
          }
          xz.getsignResumeListsInsu(pagename, this.underQuery, this.roletype).then(res => {
            // console.log('getList', res)
            if (res.status == 'ok') {
              this.notUnderData = res.msg
              this.underTotal = res.totalcount
            } else {
              this.notUnderData = []
              this.underTotal = 0
            }
            this.tableLoading = false
          })
        }
      },
      ByPerson() {

      },
      searchHandle() {
        if (this.activeName == '8' || this.activeName == '9') {
          this.getTableTitleLists()
        } else if (this.activeName == '1') {
          this.getInsurancManageByUserid()
        } else {
          this.getApprovalByProjectPower();
        }
      },
      searchFirstHandle() {},
      handleClick() {
        if (this.activeName == '1') {
          this.getInsurancManageByUserid()
        } else if (this.activeName == '2') {
          this.listQuery2.ApproverState = '待审核';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '3') {
          this.listQuery2.ApproverState = '退回';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '4') {
          this.listQuery2.ApproverState = '审批通过';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '5') {
          this.listQuery2.ApproverState = '';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '6') {
          this.listQuery2.ApproverState = '保司成功';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '7') {
          this.listQuery2.ApproverState = '保司失败';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '8') {
          this.titleQuery.ststus = '已约面'
          this.underQuery = {
            StrnowState: '待入职', //状态
            strEmpName: this.underQuery.strEmpName,
            objname: this.underQuery.objname,
            strMobile: '', // 联系方式
            strJobInf: '', //岗位
            strSource: '', //来源
            strreuser: '', //招聘顾问
            strUserkf: '', //客服
            stroutid: '', //导出选中id
            currpage: 1, // 分页
            perpage: 10,
            strSourcejl: '', //简历来源
            roletype: localStorage.loginRoletype,
            SignatureStatus: '0', //签约状态
            insuranceStatus: ''
          }
          this.getTableTitleLists()
        } else if (this.activeName == '9') {
          this.titleQuery.ststus = '在职'
          // this.underQuery.StrnowState = '入职';
          // this.underQuery.currpage = 1;
          // this.underQuery.SignatureStatus = '0';
          // this.underQuery.insuranceStatus = '1';
          this.underQuery = {
            pagecount: 10,
            currpage: 1,
            strEmpName: this.underQuery.strEmpName,
            objname: this.underQuery.objname,
            ctluserid: "",
            strIdCard: "",
            strsrvcent: "",
            strobjinstname: "",
            strEmpName: "",
            IsInOtherSys: "",
            strbusistat: "",
            stremptype: "0",
            state: "在职",
            strPhoneNum: "",
            isSign: "",
            isInsure: "否",
            NoNeedInsure: '2',
            roletype: "0383e791-72fd-4edc-aa70-2bcadminuser"
          }
          this.getTableTitleLists();
        } else if (this.activeName == '10') {
          this.listQuery2.ApproverState = '不联网';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '11') {
          this.listQuery2.ApproverState = '报增待';
          this.getApprovalByProjectPower()
        } else if (this.activeName == '12') {
          // this.listQuery2.ApproverState = '无需商保';
          this.titleQuery.ststus = '在职'
          // this.underQuery.StrnowState = '入职';
          // this.underQuery.currpage = 1;
          // this.underQuery.SignatureStatus = '0';
          // this.underQuery.insuranceStatus = '1';
          this.underQuery = {
            pagecount: 10,
            currpage: 1,
            strEmpName: this.underQuery.strEmpName,
            objname: this.underQuery.objname,
            ctluserid: "",
            strIdCard: "",
            strsrvcent: "",
            strobjinstname: "",
            strEmpName: "",
            IsInOtherSys: "",
            strbusistat: "",
            stremptype: "0",
            state: "在职",
            strPhoneNum: "",
            isSign: "",
            isInsure: "否",
            NoNeedInsure: '1',
            roletype: "0383e791-72fd-4edc-aa70-2bcadminuser"
          }
          this.getTableTitleLists();
        }
      },
      getReminderTag() { //获取 周期内是否点过  0没点过 1点过
        xz.getReminderTag(this.roletype).then(res => {
          if (res.status == 'ok') {
            console.log(res.data)
            if (res.data == '0') {
              this.visibleReading = true;
            } else {
              this.visibleReading = false;
              this.getInsurancManageByUserid();
              this.getProList();
              this.getNum();
            }
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //切换增/减员状态
      changeType(val) {
        this.type = val;
        this.showTabs = false;
        console.log(val)
        this.$nextTick(() => {
          this.activeName = '1';
        })
        setTimeout(() => {
          this.showTabs = true;
        }, 500);
        this.getInsurancManageByUserid();
        if (val == 'add') { //报增
          this.declareForm.Insurance.BusinessType = 1;
          this.batchForm.Insurance.BusinessType = 1;
          this.listQuery2.BusinessType = 1;
          this.getApprovalByProjectPower();
        } else { //报减
          this.declareForm.Insurance.BusinessType = 0;
          this.batchForm.Insurance.BusinessType = 0;
          this.listQuery2.BusinessType = 0;
          this.getApprovalByProjectPower();
        }
      },
      //获取可参保时间段列表
      getPolicyList(row) {
        let data = {
          insurable: 1,
          pageNum: 1,
          InsuranceId: row.Id,
          pageSize: 1000,
        }
        xz.getOrderPolicyManageList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.policyList = res.data.list;
          } else {
            this.policyList = []
          }
        })
      },
      policyChange(val) {
        this.declareForm.Insurance.OrderNum = val.OrderCode;
        this.declareForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.declareForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      policyChange2(val) {
        this.batchForm.Insurance.OrderNum = val.OrderCode;
        this.batchForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.batchForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      //下载模板
      downImportTemp() {
        let id;
        if (this.type == 'reduction') {
          id = '报减导入模板'
        } else {
          id = this.batchForm.Insurance.InsuranceId
        }
        xz.getInsureImportTemplate(id, this.roletype).then((res) => {
          if (res.status == "ok") {
            let q = this.type == 'add' ? '批量报增导入模板' : '批量报减导入模板'
            let name = this.insuranceName + '-' + q + '.xlsx';
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/xls`
            })
            let aLink = document.createElement("a")
            aLink.download = name; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message.error('获取模板失败')
          }
        });
      },
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        this.fileName = fileInput.files[0].name;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            this.batchForm.userListFile = res;
            this.isUploadSuccess = true;
            this.$refs['upload'].value = null;
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          pageSize: 100000000,
          pageNum: 1,
          StrprojectName: ''
        }
        xz.getProjectAllLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //取自己可取到险种
      getInsurancManageByUserid() {
        this.loading = true;
        xz.getInsurancManageByUserid(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.list;
            this.totalCount = res.data.Count;
            this.loading = false;
          } else {
            this.$message.error("获取险种列表出错!");
            this.tableData = [];
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getInsurancManageByUserid();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getInsurancManageByUserid();
      },
      //选择项目
      proChange(val) {
        this.declareForm.Insurance.ProjectName = val.StrprojectName;
        this.declareForm.Insurance.Projectid = val.Projectid;
      },
      //报增/报减
      handelDeclare(row) {
        this.clearForm();
        this.getInsurancManage(row);
        this.getPolicyList(row);
        this.proName = '';
        this.declareForm.Insurance.InsuranceId = row.Id;
        this.insuranceName = row.Bntype;
        this.showDeclare = true;
      },
      getInsurancManage(row) {
        xz.getInsurancManage(row.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.JobClasssList = res.data.InsuranceManage.EmployeeAttribute.split(',');
            let a = res.data.InsuranceManage.JobName;
            this.JobClasssTip = res.data.InsuranceManage.JobClasss;
            if (a) { // 。：； 换行处理
              a = a.replace(/。/g, '。/n')
              a = a.replace(/：/g, '：/n')
              a = a.replace(/；/g, '；/n')
              this.JobNameTip = a.split('/n');
            } else {
              this.JobNameTip = ''
            }
            this.note = res.data.InsuranceManage.SafeguardStatement;
          } else {
            this.$message.error('获取险种详情出错')
            this.JobClasssList = [];
            this.JobNameTip = '';
            this.JobClasssTip = '';
          }
        })
      },
      //确认报增/报减
      confirmSubmitDeclare() {
        this.$refs["declareForm"].validate((valid) => {
          if (valid) {
            xz.reportAddApprov(this.declareForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.getApprovalByProjectPower();
                this.showDeclare = false;
                this.clearForm();
                this.$refs['declareForm'].resetFields();
                if (res.warnMsg) {
                  this.warnMsg = res.warnMsg;
                  this.showWarnMsg = true;
                }
              } else {
                this.$message.error(res.msg);
                this.showDeclare = false;
                this.clearForm();
              }
            })
          }
        })
      },
      clearForm() {
        this.policy = '';
        this.proName = '';
        this.declareForm = { //报增减表单
          Insurance: {
            BusinessType: this.type == 'add' ? 1 : 0, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userList: [{
            MainlinsuredName: '', //姓名
            MainlinsuredCardId: '', //证件号
            Idtype: '', //证件类型
            MainlinsuredPhone: '', //手机号码
            JobName: '', //岗位名称
            JobClasss: '', //职业类别
            EmployeeAttribute: '', //员工属性
          }]
        }
      },
      //选择项目（批量）
      proChange2(val) {
        this.batchForm.Insurance.ProjectName = val.StrprojectName;
        this.batchForm.Insurance.Projectid = val.Projectid;
      },
      //批量报增
      BatchDeclare(row) {
        this.proName = '';
        this.policy2 = '';
        this.fileName = '';
        this.failReason = '';
        this.failBase64 = '';
        this.hasDownload = false;
        this.batchForm = {
          Insurance: {
            BusinessType: this.type == 'add' ? 1 : 0, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userListFile: ''
        }
        if (row) {
          this.getPolicyList(row);
          this.getInsurancManage(row);
          this.batchForm.Insurance.InsuranceId = row.Id;
          this.insuranceName = row.Bntype;
          this.MedicalinsuranceType = row.MedicalinsuranceType;
        }
        this.showBatchDeclare = true;
      },
      //批量报增/报减
      confirmSubmitBatch() {
        if (!this.batchForm.Insurance.Projectid) {
          this.$message.warning('请选择项目')
        } else {
          xz.reportAddApprov(this.batchForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('提交成功');
              this.getApprovalByProjectPower();
              this.showBatchDeclare = false;
              this.clearBatchForm();
              if (res.warnMsg) {
                this.warnMsg = res.warnMsg;
                this.showWarnMsg = true;
              }
            } else {
              this.loading = false;
              this.failReason = res.msg;
              this.failBase64 = res.data;
              // this.$message({
              //   type: 'error',
              //   showClose: true,
              //   message: res.msg
              // })
              // this.showBatchDeclare = false;
            }
          })
        }
      },
      clearBatchForm() {
        this.proName = '';
        this.policy2 = '';
        this.batchForm = {
          Insurance: {
            BusinessType: this.type == 'add' ? 1 : 0, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userListFile: ''
        }
      },
      //下载失败名单
      downFailTemp() {
        let url = this.failBase64;
        let base64 = url.toString()
        let byteCharacters = atob(
          base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
        )
        let byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        let byteArray = new Uint8Array(byteNumbers)
        let blob = new Blob([byteArray], {
          type: `application/pdf`
        })
        let aLink = document.createElement("a");
        aLink.download = '失败名单.xls' //这里写保存时的图片名称
        aLink.href = URL.createObjectURL(blob)
        aLink.click()
        this.hasDownload = true;
        this.loading = false;
      },
      //获取待审核/退回/通过列表
      getApprovalByProjectPower() {
        this.loading = true;
        xz.getApprovalByProjectPower(this.listQuery2, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tableData2 = res.data.ret;
            this.totalCount = res.data.totalCount;
            this.loading = false;
            this.approveNum = 0; //待审核数量
            this.returnNum = 0; //退回数量
            this.passNum = 0; //通过数量
            this.successNum = 0;
            this.failNum = 0;
            this.histotyNum = 0; //历史数据数量
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.ApproverState == '待审核') {
                  this.approveNum = element.EntNum
                } else if (element.ApproverState == '审批通过') {
                  this.passNum = element.EntNum
                } else if (element.ApproverState == '退回') {
                  this.returnNum = element.EntNum
                } else if (element.ApproverState == '保司成功') {
                  this.successNum = element.EntNum
                } else if (element.ApproverState == '保司失败') {
                  this.failNum = element.EntNum
                }
                this.histotyNum = this.approveNum + this.passNum + this.returnNum + this.successNum + this.failNum;
              });
            }
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
            this.tableData2 = [];
          }
        })
      },
      getNum() {
        xz.getApprovalByProjectPower(this.listQuery2, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.approveNum = 0; //待审核数量
            this.returnNum = 0; //退回数量
            this.passNum = 0; //通过数量
            this.histotyNum = 0; //历史数据数量
            if (res.data.collect.length > 0) {
              res.data.collect.forEach(element => {
                if (element.ApproverState == '待审核') {
                  this.approveNum = element.EntNum
                } else if (element.ApproverState == '审批通过') {
                  this.passNum = element.EntNum
                } else if (element.ApproverState == '退回') {
                  this.returnNum = element.EntNum
                } else if (element.ApproverState == '保司成功') {
                  this.successNum = element.EntNum
                } else if (element.ApproverState == '保司失败') {
                  this.failNum = element.EntNum
                }
                this.histotyNum = this.approveNum + this.passNum + this.returnNum + this.successNum + this.failNum;
              });
            }
          } else {
            this.approveNum = 0; //待审核数量
            this.returnNum = 0; //退回数量
            this.passNum = 0; //通过数量
            this.histotyNum = 0; //历史数据数量
          }
        })
      },
      currentChange2(val) {
        this.listQuery2.pageNum = Number(val);
        this.getApprovalByProjectPower();
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery2.pageNum = 1;
        this.listQuery2.pageSize = val;
        this.getApprovalByProjectPower();
      },
      //查看明细
      getDetail(row, index) {
        if (this.activeName == 7) {
          this.detailQuery.ServiceProviderStatu = 0;
        } else {
          this.detailQuery.ServiceProviderStatu = '';
        }
        let ref = 'pop' + index;
        this.$refs[ref].doShow();
        this.detailQuery.Id = row.Id;
        this.detailQuery.pageNum = 1;
        this.detailQuery.MainlinsuredCardId = '';
        this.getApprovalDetails();
      },
      //获取明细列表
      getApprovalDetails() {
        this.detLoading = true;
        xz.getApprovalDetails(this.detailQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detailTable = res.data.ret;
            this.detTotal = res.data.totalCount;
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.detailTable = [];
            this.detTotal = 0;
            this.$message.error('系统出错！');
          }
        })
      },
      detCurrentChange(val) {
        this.detailQuery.pageNum = Number(val);
        this.getApprovalDetails();
      },
      detHandleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.detailQuery.pageNum = 1;
        this.detailQuery.pageSize = val;
        this.getApprovalDetails();
      },
      //审批
      approve(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showApprove = true;
      },
      //确认审批通过
      confirmPass() {
        xz.approvalEnd(this.approveIds, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('审批成功');
            this.getApprovalByProjectPower();
            this.showApprove = false;
          } else {
            this.showApprove = false;
            this.$message.error(res.msg);
          }
        })
      },
      //退回
      goBack(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showBack = true;
      },
      //确认退回
      confirmBack() {
        let data = {
          id: this.approveIds,
          ReturnReasons: this.ReturnReasons
        }
        xz.approvalReturn(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('退回成功');
            this.getApprovalByProjectPower();
            this.showBack = false;
          } else {
            this.showBack = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //初保
      firstInsure() {
        if (!this.ispending) {
          this.ispending = true;
          xz.applyInsured('', this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('初保提交成功')
              setTimeout(() => {
                this.ispending = false;
              }, 1000);
            } else {
              this.$message.error('系统出错！');
            }
          })
        }
      },
      //查看资料详情
      getTipDtl() {
        // let path = 'https://emp.joball.net/cloudexcel/excel/E20231107151241922.xlsx';
        // const aTag = document.createElement('a')
        // aTag.href = path;
        // aTag.setAttribute('download', name);
        // aTag.click();
        let routeUrl = this.$router.resolve({
          path: "/model",
        });
        window.open(routeUrl.href, "_blank");
      },
      expList() {
        this.loading = true;
        let data = {
          IsExport: '1',
          BusinessType: this.listQuery2.BusinessType,
          pageNum: 1,
          pageSize: 10000
        }
        xz.getApprovalByProjectPower(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' : this.activeName == 4 ? '审核通过' : '历史数据';
            aLink.download = type + name + '列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //导出明细
      expDtlList() {
        let data = {
          IsExport: '1',
          Id: this.detailQuery.Id,
          pageNum: 1,
          pageSize: 10000
        }
        this.exports(data)
      },
      exports(data) {
        this.detLoading = true;
        xz.getApprovalDetails(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detLoading = false;
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' ? this.activeName == 2 : '审核通过' : '历史数据';
            aLink.download = type + name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.$message.error('导出失败！');
          }
        })
      },
      //导出保司成功明细
      expICS(data) {
        this.detLoading = true;
        xz.GetApprovalSuccess(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.detLoading = false;
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let name = this.activeName == 6 ? '保司成功' : this.activeName == 7 ? '保司失败' : '';
            aLink.download = name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.detLoading = false;
          } else {
            this.detLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //退回明细个人编辑
      editBackDtl(row) {
        this.backDtlInfo = {
            Id: row.Id,
            MainlinsuredName: row.MainlinsuredName,
            Idtype: row.Idtype,
            MainlinsuredCardId: row.MainlinsuredCardId,
            MainlinsuredPhone: row.MainlinsuredPhone,
            JobName: row.JobName,
            EmployeeAttribute: row.EmployeeAttribute,
            JobClasss: row.JobClasss,
          },
          this.showEditBackDtl = true;
      },
      confirmEditBackDtl() {
        this.$refs["backDtlInfo"].validate((valid) => {
          if (valid) {
            xz.updataApprovalDetail(this.backDtlInfo, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getApprovalDetails();
                this.showEditBackDtl = false;
                this.$message.success('修改成功！');
              } else {
                this.showEditBackDtl = false;
                this.$message.error('系统出错！');
              }
            })
          }
        })
      },
      delBackDtl(row) {
        this.delId = row.Id;
        this.delName = row.MainlinsuredName;
        this.showDel = true;
      },
      confirmDel() {
        xz.delApprovalDetail(this.delId, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalDetails();
            this.showDel = false;
            this.$message.success('删除成功！');
          } else {
            this.showDel = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //重新提交审批
      resubmit(row) {
        this.approveIds = row.Id;
        this.approveBatch = row.BatchNum;
        this.showResubmit = true;
      },
      confirmResubmit() {
        xz.submitApproval(this.approveIds, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.showResubmit = false;
            this.$message.success('提交成功！');
          } else {
            this.showResubmit = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //重新导入
      reimport(row) {
        this.reimportForm.oldid = row.Id;
        this.showReimport = true;
        this.fileName = '';
      },
      //文件读取
      async importf2() {
        const fileInput = this.$refs.upload;
        this.fileName = fileInput.files[0].name;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            this.reimportForm.userListFile = res;
            this.$refs['upload'].value = null;
          } else {
            this.$message("上传Excel失败!");
            this.reimportForm.userListFile = '';
            this.$refs['upload'].value = null;
          }
        })
      },
      confirmReimport() {
        xz.reportAddApprov(this.reimportForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$refs['upload'].value = null;
            this.getApprovalByProjectPower();
            this.showReimport = false;
            this.$message.success('重新导入成功！');
            if (res.warnMsg) {
              this.warnMsg = res.warnMsg;
              this.showWarnMsg = true;
            }
          } else {
            this.$refs['upload'].value = null;
            this.showResubmit = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //关闭明细
      closePopover(index) {
        let ref = 'pop' + index;
        console.log(this.$refs[ref])
        this.$refs[ref].doClose();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //批量导出明细
      // expBatchDtlList() {
      //   if (this.multipleSelection.length == 0) {
      //     this.$message.warning('请先选择批次！')
      //   } else {
      //     let ids = '';
      //     this.multipleSelection.forEach((element, index) => {
      //       if (index == 0) {
      //         ids = element.Id;
      //       } else {
      //         ids = ids + ',' + element.Id;
      //       }
      //       if (index == this.multipleSelection.length - 1) {
      //         let data = {
      //           IsExport: '1',
      //           Id: ids,
      //           BusinessType: this.declareForm.Insurance.BusinessType,
      //           pageNum: 1,
      //           pageSize: 10000
      //         }
      //         if (this.activeName == 6 || this.activeName == 7) {
      //           this.expICS(data)
      //         } else {
      //           this.exports(data)
      //         }
      //       }
      //     })
      //   }
      // },
      expBatchDtlList(){
        this.loading = true;
        let d = JSON.parse(JSON.stringify(this.listQuery2))
        d.IsExport = '2';
        d.pageSize = 10000;
        d.pageNum = 1;
         xz.getApprovalByProjectPower(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            let type = this.type == 'add' ? '报增' : '报减';
            let name = this.activeName == 2 ? '待核' : this.activeName == 3 ? '被退回' : this.activeName == 4 ? '审核通过' : '历史数据';
            aLink.download = type + name + '明细列表.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.loading = false;
          } else {
            this.$message.error('导出失败')
            this.loading = false;
          }
        })
      },
      //关闭批量弹窗
      cancelBatch() {
        if (this.failBase64 && !this.hasDownload) {
          this.$message.warning('请先下载失败名单！');
        } else {
          this.proName = '';
          this.showBatchDeclare = false;
        }
      },
      viewList() {
        xz.doReminderTag(this.roletype).then(res => {
          if (res.status == 'ok') {
            // this.visibleReading = false;
            // this.getInsurancManageByUserid();
            // this.getProList();
            // this.getNum();
            localStorage.setItem("insureActive", 'underGuarantee')
            this.$router.push({
              path: '/underGuarantee'
            })
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //作废 已退回的
      approverCancel(row) {
        xz.approverCancel(row.Id).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.$message.success('作废成功')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //报增待确认 确认
      confirmc(id) {
        xz.ConfirmedEnterAdd(id, this.roletype, 'ConfirmedEnterAdd').then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.$message.success('操作成功')
          } else {
            this.getApprovalByProjectPower();
            // this.$message.error(res.msg)
            this.failReason = res.msg;
            this.failBase64 = res.data;
            this.showConfirmFail = true;
          }
        })
      },
      batchConfirm() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请先选择批次！')
        } else {
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id);
          });
          this.confirmc(arr.toString());
        }
      },
      conrirmDel(id) {
        xz.ConfirmedEnterAdd(id, this.roletype, 'DeleteConfirmedEnter').then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.$message.success('作废成功')
          } else {
            this.getApprovalByProjectPower();
            this.$message.error(res.msg)
          }
        })
      },
      passAuth(row) {
        this.loading = true;
        xz.PassApplyInfo([{
          id: row.Id
        }], this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getApprovalByProjectPower();
            this.loading = false;
            this.$message.success('操作成功！');
          } else {
            this.loading = false;
            this.$message.error('系统出错！');
          }
        })
      },
      //编辑
      editDtl(row) {
        this.DtlInfo = {
          Id: row.Id,
          ParentId: row.ParentId,
          MainlinsuredName: row.MainlinsuredName,
          MainlinsuredCardId: row.MainlinsuredCardId,
        }
        this.showEditDtl = true;
      },
      confirmEditDtl() {
        this.$refs["DtlInfo"].validate((valid) => {
          if (valid) {
            xz.UpdateApplyInfo([this.DtlInfo], this.roletype).then(res => {
              if (res.status == 'ok') {
                this.getApprovalDetails();
                this.showEditDtl = false;
                this.$message.success('修改成功！');
              } else {
                this.showEditDtl = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      reduction() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          let canReduct = true;
          let hasMore = false;
          let errName = '';
          let ids = [];
          this.multipleSelection.forEach((e, index) => {
            if (e.isInsure == '否') {
              canReduct = false;
            }
            if (e.InsureInfo != undefined && e.InsureInfo.length > 1) {
              hasMore = true;
              errName = e.StrEmpName;
            } else if (e.InsureInfo != undefined && e.InsureInfo.length == 1) {
              ids.push(e.InsureInfo[0].Id)
            }
            if (index == this.multipleSelection.length - 1) {
              if (hasMore) {
                this.$message.error(errName + '有多个在保记录，请前往在保人员页面操作')
              } else if (!canReduct) {
                this.$message.warning('请选择在保的人员报减')
              } else if (canReduct) {
                xz.ReportReduce(ids.toString(), this.roletype).then(res => {
                  if (res.status == 'ok') {
                    this.$message.success('报减成功！');
                    if (res.warnMsg) {
                      this.warnMsg = res.warnMsg;
                      this.showWarnMsg = true;
                    }
                  } else {
                    this.$message.error(res.msg);
                  }
                })
              }
            }
          });

        }
      },
      expList2() {
        let d = JSON.parse(JSON.stringify(this.underQuery));
        d.pagecount = 100000;
        d.IsExport = '1';
        this.isExping = true;
        xz.bgetempcustlist(d, this.roletype, 'ByPerson').then((res) => {
          if (res.status == 'ok') {
            try {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              let aLink = document.createElement("a")
              let name = this.activeName == '8' ? '待入职商保列表.xls' : this.activeName == '9' ? '在职未商保.xls' : '无需商保.xls';
              aLink.download = name; //这里写保存时的名称
              aLink.href = URL.createObjectURL(blob)
              aLink.click();
              this.isExping = false;
            } catch (e) {
              this.$message.error('导出失败');
              this.isExping = false;
            }
          } else {
            this.$message.error(res.msg);
            this.isExping = false;
          }
        })
      },
      noNeedIns() {
        let that = this
        if (this.isNull(this.underMultipleList)) {
          that.$message({
            type: 'warning',
            message: '请至少选择一条数据操作'
          })
          return false;
        } else {
          let arr = [];
          this.underMultipleList.forEach(e => {
            let d = {
              StrExcelPath: e.StrExcelPath,
              IntExcelLine: e.IntExcelLine,
              NoNeedInsure: '1'
            }
            arr.push(d)
          });
          this.isBtnLoading = true;
          xz.updatePersonNoNeedInsure(arr, localStorage.loginRoletype).then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isBtnLoading = false;
              this.$message.success('操作成功');
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let str = `?pageNum=${1}&pageSize=${10000}`
        xz.ArdCurStatGetFun('GetLegalSubjectsList', str).then(res => {
          if (res.status == 'ok') {
            const excludedCompanies = [
              "无锡杰博人力资源有限公司",
              "杰博人力资源(西安)有限公司",
              "上海才服企业管理咨询有限公司",
              "杰博(重庆)人力资源服务有限公司",
              "南通市杰博人力资源有限公司"
            ];

            // 过滤掉 companyName 在 excludedCompanies 中的数据
            this.legList = res.data.date.filter(item => !excludedCompanies.includes(item.companyName));
          } else {
            this.legList = [];
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .note_ins_txt {
    margin: 0 0 6px 0;
    font-size: 14px;
    color: #666;
    font-weight: 600;
  }

  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .err_txt {
    color: red;
    font-size: 12px;
  }

  .insureNote {
    color: red;
    max-width: 750px;
  }

  .JobClasssTip {
    color: red;
    text-decoration: underline;
  }

  .diaTitle {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .weight {
    font-weight: bolder;
  }

  .note_txt {
    padding-right: 10px;
  }

  .note_txt p {
    line-height: 24px;
  }

  .readDialog {
    // height: 400px;
    // overflow-y: scroll;
    // position: relative;
    padding: 20px 0 0 20px;
    font-size: 14px;
  }

  .dialogFoot {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background: #f3f3f3;
  }

  .overSet {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
  }

  .btnBox {
    padding: 20px 0 50px 0;
    width: 910px;
    display: flex;
    justify-content: center;
  }

  .infoTips {
    margin-left: 30px;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }

  .fieldBox {
    max-height: 200px;
    overflow-y: scroll;
  }

  .status-tag {
    display: inline-block;
    padding: 4px 10px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    color: #fff;
  }

  .success {
    background-color: #67c23a;
  }

  .danger {
    background-color: #f56c6c;
  }

  .tips {
    margin-left: 30px;
    font-size: 14px;
    padding-bottom: 3px;
    color: red;
  }
</style>
<style>
  .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_declare .doc_table .el-table__body td.el-table__cell,
  .ins_dialog_box .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_declare .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_declare .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_declare .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_declare .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_declare .declareForm .el-form-item__error {
    top: 34px;
  }

  .insureApprove .el-dialog__body {
    padding: 10px 20px;
  }

  .reading .el-dialog__body {
    padding: 5px;
  }

  .reading .el-dialog__header {
    padding: 0;
  }
</style>